import { Link } from "react-router-dom";

import { MdOutlineKeyboardArrowRight } from "react-icons/md";

export default function PageHeading({ title }) {
  return (
    <div className="call-bg overlay py-20">
      <div className="mx-auto text-4xl text-center relative">
        <h5 className="text-white font-semibold leading-normal capitalize">
          {title}
        </h5>
        <div className="flex justify-center text-lg mt-3">
          <div className="flex gap-4 items-center">
            <Link to={"/"} className="text-white">
              Home
            </Link>
            <MdOutlineKeyboardArrowRight className="fill-white text-xl" />
            <p className="text-white">{title}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
